import { render, staticRenderFns } from "./ManageRecommendStatus.vue?vue&type=template&id=26788a35&scoped=true"
import script from "./ManageRecommendStatus.vue?vue&type=script&lang=js"
export * from "./ManageRecommendStatus.vue?vue&type=script&lang=js"
import style0 from "./ManageRecommendStatus.vue?vue&type=style&index=0&id=26788a35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26788a35",
  null
  
)

export default component.exports